import { uaTool } from '@tencent/thumbplayer-core';
import { __awaiter, __generator } from 'tslib';

/**
 * @param player H5Player 播放器实例
 * @param options 截图配置
 * @param watermarks 水印配置，截图后将水印贴上
 */
function captureVideo(player, options, watermarks) {
    return __awaiter(this, void 0, void 0, function () {
        var dx, dy, dh, dw, captureData, canvas, ctx;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dx = options.dx, dy = options.dy, dh = options.dh, dw = options.dw;
                    return [4 /*yield*/, player.captureVideo(dx, dy, dw, dh)];
                case 1:
                    captureData = _a.sent();
                    // 如果接口没有正常返回，这里包一层，返回一个空数据回去
                    if (!captureData) {
                        return [2 /*return*/, {
                                captureX: dx,
                                captureY: dy,
                                captureWidth: dw,
                                captureHeight: dh,
                                playtime: player.playtime,
                                data: null,
                            }];
                    }
                    // 如果无水印配置，直接返回截图数据
                    if (!(Array.isArray(watermarks)))
                        return [2 /*return*/, captureData];
                    canvas = document.createElement('canvas');
                    ctx = canvas.getContext('2d');
                    canvas.width = dw;
                    canvas.height = dh;
                    ctx.putImageData(captureData.data, 0, 0);
                    watermarks === null || watermarks === void 0 ? void 0 : watermarks.forEach(function (watermark) {
                        if (isTextWatermark(watermark)) {
                            return drawTextWatermark(ctx, watermark);
                        }
                        drawImageWatermark(ctx, watermark);
                    });
                    captureData.data = ctx.getImageData(0, 0, dw, dh);
                    return [2 /*return*/, captureData];
            }
        });
    });
}
/**
 * 将视频截图下载到本地
 * @param captureData 截图视频数据
 * @param filename 下载文件名
 */
function downloadCapture(captureData, filename, mime) {
    var canvas = document.createElement('canvas');
    canvas.width = captureData.captureWidth;
    canvas.height = captureData.captureHeight;
    var ctx = canvas.getContext('2d');
    ctx.putImageData(captureData.data, 0, 0);
    var imgBase64 = canvas.toDataURL(mime);
    var link = document.createElement('a');
    link.href = imgBase64;
    link.download = filename;
    link.click();
}
function isTextWatermark(watermark) {
    return 'content' in watermark;
}
/**
 * 绘制文字水印
 * @param ctx canvas 绘图上下文
 * @param watermark 文字水印配置
 */
function drawTextWatermark(ctx, watermark) {
    var drawText = watermark.mode === 'stroke' ? ctx.strokeText.bind(ctx) : ctx.fillText.bind(ctx);
    ctx.font = watermark.font || DEFAULT_FONT;
    ctx.fillStyle = watermark.color || DEFAULT_COLOR;
    ctx.strokeStyle = watermark.color || DEFAULT_COLOR;
    ctx.globalAlpha = watermark.alpha || DEFAULT_ALPHA;
    drawText(watermark.content, watermark.dx, watermark.dy);
}
/**
 * 绘制图片水印
 * @param ctx canvas 绘图上下文
 * @param watermark 图片水印配置
 */
function drawImageWatermark(ctx, watermark) {
    var isImageReady = watermark.image.complete;
    var doWatermark = function () {
        var image = watermark.image, dx = watermark.dx, dy = watermark.dy, width = watermark.width, height = watermark.height;
        var imageWidth = image.width, imageHeight = image.height;
        ctx.globalAlpha = watermark.alpha || DEFAULT_ALPHA;
        ctx.drawImage(image, dx, dy, width || imageWidth, height || imageHeight);
    };
    if (isImageReady) {
        return doWatermark();
    }
    watermark.image.addEventListener('load', doWatermark);
}
var DEFAULT_ALPHA = 1;
var DEFAULT_FONT = '18px sans-serif';
var DEFAULT_COLOR = '#fff';

/* eslint-disable @typescript-eslint/naming-convention */
/** 是否移动端ua，兼容老的逻辑 */
var isMobile = uaTool.mobile;
/** txp_none */
var txpHideClass = 'txp_none';
var txpDisableClass = 'txp_disabled';
var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#x27;',
    '`': '&#x60;',
    '=': '&#x3D;',
};
var badChars = /[&<>"'`=]/g;
function xssFilter(str) {
    if (badChars.test(str)) {
        return str.replace(badChars, function (k) { return escapeMap[k]; });
    }
    return str;
}

export { captureVideo, downloadCapture, isMobile, txpDisableClass, txpHideClass, xssFilter };
